import React, { useState, useRef } from "react";
import api from "../services/api";
import { TextField, Button, Box, Typography } from "@mui/material";

function Upload({ onUploadSuccess, customerId, petId, serviceId, groomerId, userId }) {
  const [file, setFile] = useState(null);
  const [caption, setCaption] = useState("");
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);
  const captionInputRef = useRef(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleCaptionChange = (e) => {
    setCaption(e.target.value);
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) return;
    setUploading(true);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("caption", caption);
    formData.append("folder", "default");
    if(customerId) formData.append("customerId", customerId);
    if(petId) formData.append("petId", petId);
    if(serviceId) formData.append("serviceId", serviceId);
    if(groomerId) formData.append("groomerId", groomerId);
    if(userId) formData.append("userId", userId);

    try {
      const response = await api.post("/upload", formData);
      //console.log("File uploaded:", response.data);
      if (onUploadSuccess) {
        onUploadSuccess(response.data);
      }
      // Reset the form fields and remove focus
      setFile(null);
      setCaption("");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      if (captionInputRef.current) {
        captionInputRef.current.blur();
      }
    } catch (error) {
      //console.error("Upload failed:", error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <form onSubmit={handleUpload}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {/* Custom File Input */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <input
            type="file"
            id="upload-file"
            onChange={handleFileChange}
            accept="image/*"
            ref={fileInputRef}
            style={{ display: 'none' }}
          />
          <label htmlFor="upload-file">
            <Button variant="contained" component="span">
              Choose File
            </Button>
          </label>
          <Typography variant="body2">
            {file ? file.name : "No file chosen"}
          </Typography>
        </Box>
        <TextField
          label="Description"
          variant="outlined"
          size="small"
          value={caption}
          onChange={handleCaptionChange}
          placeholder="Enter description"
          inputRef={captionInputRef}
        />
        <Button type="submit" variant="contained" color="primary" disabled={uploading}>
          {uploading ? "Uploading..." : "Upload"}
        </Button>
      </Box>
    </form>
  );
}

export default Upload;